export default {"src":"/_next/static/image/public/images/ic_empty_notifications.96edbcdf76ff973ae6f13eebbc3fcb7e.svg","height":152,"width":126};